import { useState } from 'react';

interface NewFolderDialogProps {
  currentFolderName: string;
  onConfirm: (name: string) => void;
  onCancel: () => void;
}

export default function NewFolderDialog({ currentFolderName, onConfirm, onCancel }: NewFolderDialogProps) {
  const [name, setName] = useState('');

  const handleCreate = () => {
    if (!name.trim()) return;
    onConfirm(name.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onCancel}>
      <div className="bg-background-50 rounded-xl p-6 max-w-sm w-full border border-background-200 animate-in fade-in zoom-in-95 duration-150" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-lg font-semibold text-foreground-900 mb-4">새 폴더 만들기</h2>
        <p className="text-sm text-foreground-500 mb-4">위치: {currentFolderName}</p>
        <input
          type="text" value={name} onChange={(e) => setName(e.target.value)}
          placeholder="폴더 이름"
          className="w-full px-3 py-2.5 text-sm bg-background-100 border border-background-300 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 text-foreground-800 placeholder-foreground-400 mb-4"
          autoFocus
          onKeyDown={(e) => { if (e.key === 'Enter') handleCreate(); }}
        />
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm font-medium rounded-lg border border-background-300 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">취소</button>
          <button onClick={handleCreate} disabled={!name.trim()} className="px-4 py-2 text-sm font-medium rounded-lg bg-primary-500 text-white hover:bg-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap">만들기</button>
        </div>
      </div>
    </div>
  );
}